module.exports = __webpack_public_path__ + "9e26c8f2269d749b4d2dfa46bf5355d4.svg";